export default __webpack_public_path__ + "static/media/white-full-logo.ce6c0cbf.svg";